/* @ngInject */
export default function ImageCacheService($q, CacheService) {
    function isImageServable(src) {
        var deferred = $q.defer();

        var image = new Image();
        image.onerror = function () {
            deferred.resolve(false);
        };
        image.onload = function () {
            deferred.resolve(true);
        };
        image.src = src;

        return deferred.promise;
    }

    function imagePropertySetter(definitions) {
        if (definitions.childDefinitions) {
            imagePropertySetter(definitions.childDefinitions);
        } else {
            definitions.forEach(function (definition) {
                if (definition.childDefinitions.length > 0) {
                    imagePropertySetter(definition.childDefinitions);
                }

                var host = 'search.kemet.com';
                //var host = "localhost";
                var protocol = 'https';
                //var protocol = "http";
                definition.img = {};

                definition.img.src = protocol + '://' + host;
                definition.img.src += CacheService.getImagesBy().src;
                definition.img.alt = imageProp.alt;
                definition.img.title = imageProp.title;
            });
            for (var i = 0; i < definitions.length; i++) {

            }
        }
    }

    return {
        isImageServable: isImageServable,
        setImageProperty: imagePropertySetter,
    };
}
